export enum MontazaTabEnum {
  PregledDanaTab = 'PregledDanaTab',
  UredjivanjeTab = 'UredjivanjeTab',
  MontazaTab = 'MontazaTab',
}



// WEBPACK FOOTER //
// ./src/app/enums/montaza-tab.enum.ts